import { createStaleChunkRecovery } from './staleChunkRecovery';

/**
 * ONE recovery for the whole app, ONE guard per surface. The lazy route
 * `import()` and the upload Worker's `importScripts` each hold their own
 * sessionStorage marker and each release only their own (sen-5 F6): a route
 * import succeeding on every boot used to clear the worker's marker and turn
 * a persistent worker chunk failure into a reload loop. Bounded either way —
 * at most one reload per surface until that surface reports recovery.
 */
export const staleChunkRecovery = createStaleChunkRecovery({
  reload: () => window.location.reload(),
  storage: window.sessionStorage,
});
